import { render } from "./ComposeMessage.vue?vue&type=template&id=036608a6"
import script from "./ComposeMessage.vue?vue&type=script&lang=js"
export * from "./ComposeMessage.vue?vue&type=script&lang=js"

import "./ComposeMessage.vue?vue&type=style&index=0&id=036608a6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__